var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './PhonePage.module.css';
import { useCallback, useEffect, useRef, useState } from 'react';
import { PageLayout } from '../../Components/PageLayout';
import { OTPInput } from '../../Components/BaseComponents/OTPInput';
import { CoolDownDefault } from '../../../constanst';
import { useUpdateTimer } from '../../hooks/useUpdateTimer';
import { observer } from 'mobx-react-lite';
import { useApplication, useStepController, } from '../../Contexts/ApplicationContext';
import { resendVerificationPhoneCode, sendVerificationPhoneCode, } from '../../../Services/methods/verifications';
import { useAnalytics } from '../../Contexts/AnalyticsContext';
import { useMerchant } from '../../Contexts/MerchantContext';
import { AsYouType } from 'libphonenumber-js';
var OTP_LENGTH = 5;
export var OtpPhonePage = observer(function () {
    var _a = useState(''), code = _a[0], setCode = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var orderFacade = useApplication().orderFacade;
    var updateStepInfo = useStepController().updateStepInfo;
    var phone = orderFacade.userInfo.phone;
    var merchant = useMerchant();
    var _c = useState(undefined), error = _c[0], setError = _c[1];
    var coolDown = merchant.config.smsCoolDown || CoolDownDefault;
    var _d = useUpdateTimer(coolDown), setTimer = _d.setTimer, text = _d.text, process = _d.process;
    var track = useAnalytics().track;
    var wasAttempt = useRef(false);
    var handleRepeat = useCallback(function () {
        resendVerificationPhoneCode()
            .then(function () {
            setTimer(coolDown);
        })
            .catch(function (err) {
            var _a, _b;
            var errorMsg = ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || 'Something went wrong';
            setError(errorMsg);
        });
    }, [coolDown, setTimer]);
    var handleSubmit = useCallback(function () {
        setLoading(true);
        track('phone_sms_submitted');
        sendVerificationPhoneCode({ code: code })
            .then(function (res) {
            var step = res.data;
            updateStepInfo(step);
        })
            .catch(function () {
            var errorText = 'OTP code is invalid';
            setError(errorText);
            track('error_raised', { error: errorText });
        })
            .finally(function () { return setLoading(false); });
    }, [code, updateStepInfo, track]);
    var handleChange = useCallback(function (value) {
        if (wasAttempt.current) {
            wasAttempt.current = false;
        }
        if (error) {
            setError('');
        }
        setCode(value);
    }, [error]);
    useEffect(function () {
        if (code.length === OTP_LENGTH && !wasAttempt.current) {
            handleSubmit();
            wasAttempt.current = true;
        }
    }, [wasAttempt, code, handleSubmit]);
    return (_jsxs(PageLayout, __assign({ footer: {
            actionButtonLabel: 'Next',
            secondaryButtonLabel: text,
            onSecondaryButtonClick: handleRepeat,
            secondaryButtonDisabled: process,
            buttonClick: handleSubmit,
            actionButtonLoader: loading,
            actionButtonDisable: code.length !== OTP_LENGTH,
        } }, { children: [_jsx("h2", __assign({ className: styles.title }, { children: "Enter code from SMS" })), _jsxs("p", __assign({ className: styles.text }, { children: ["We have sent you sms with a code to number", ' ', phone && new AsYouType().input(phone)] })), _jsx(OTPInput, { otpLength: OTP_LENGTH, isError: Boolean(error), helperText: error, onChange: handleChange, value: code })] })));
});
